import firmaPkDeclaImage from '../../../imagenes/firma-pk-decla.png';

async function imageUrlToDataUrl(url, mimeType = 'image/png') {
  const response = await fetch(url);
  if (!response.ok) throw new Error('No se pudo cargar la firma.');
  const bytes = new Uint8Array(await response.arrayBuffer());
  let binary = '';
  for (let i = 0; i < bytes.length; i += 1) binary += String.fromCharCode(bytes[i]);
  return `data:${mimeType};base64,${btoa(binary)}`;
}

/** Firma centrada bajo los bloques de tabla (como plantilla Invoice 5019). */
export async function appendGradeHeightSignatureExcel(ws, wb, startRow) {
  const r = startRow + 1;
  ws.getRow(r).height = 42;
  const sigBase64 = await imageUrlToDataUrl(firmaPkDeclaImage);
  const signatureId = wb.addImage({ base64: sigBase64, extension: 'png' });
  ws.addImage(signatureId, {
    tl: { col: 2.45, row: r - 1 + 0.05 },
    ext: { width: 132, height: 46 },
    editAs: 'oneCell',
  });
  return r + 2;
}

export function drawGradeHeightSignaturePdf(doc, y) {
  const pageW = doc.internal.pageSize.getWidth();
  const sigW = 44;
  const sigH = 16;
  const x = (pageW - sigW) / 2;
  doc.addImage(firmaPkDeclaImage, 'PNG', x, y, sigW, sigH);
  return y + sigH + 4;
}
